import React from 'react';
import { getServiceName } from '../../utils/consts';
import ReactHtmlParser from 'react-html-parser';
import translateString from '../../utils/Locales';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

// Styles 
import './style.css';
import './bootstrap.min.css';
import './owl.carousel.css';
import './owl.theme.css';
import './owl.transitions.css';
import './animate.css';
import './preloader.css';
import Utils from '../../utils/utils';

let t = translateString;

export default class LandingPage extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
            playVideo: false,
            visible: false
        };
    }

    handleResize() {
        this.setState({ bannerHeight: window.innerHeight });
    }

    async componentDidMount() {

        window.addEventListener('resize', this.handleResize());

        document.title = getServiceName() + ' - Homepage';

       /*  const app = initializeApp(firebaseConfig);
        var analytics = getAnalytics(app); */

        Utils.setAnalyticsPage('Homepage');

        this.productRef = React.createRef();
        this.homeRef = React.createRef();
        this.featuresRef = React.createRef();
        this.pianiRef = React.createRef();
        this.videoRef = React.createRef();

        //setUserProperties(analytics, { main_user: true });
        
        this.setState({ });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize());
    }



    render () {

        return (
            <div className='mainBody' ref={this.homeRef} style={{ width: '100%', height: '100%' }}>
                <link rel="stylesheet" href="bootstrap-4.1.1-dist/css/bootstrap.min.css" />
                <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-Zenh87qX5JnK2Jl0vWa8Ck2rdkQ2Bzep5IDxbcnCeuOxjzrPF/et3URy9Bv1WTRi" crossorigin="anonymous"></link>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.3.1/css/all.css" integrity="sha384-mzrmE5qonljUremFsqc01SB46JvROS7bZs3IO2EmfFsd15uHvIt+Y8vEf7N7fWAU" crossorigin="anonymous" />
        
                <header id='home'>
                    <Navbar bg="light" expand="lg" fixed='top' onToggle={() => this.setState({visible: !this.state.visible})}>
                        <Container>
                            <Navbar.Brand onClick={() => window.location.href='/#/main/home'}>
                                <img alt="" className='navbar-brand' style={{width: "auto", height: 80, cursor: 'pointer', margin: 0}}  src={require('../../images/icon.png')}/>
                            </Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav" style={{padding:0}}>
                                <Nav className="hamburgerStyle">
                                    <Nav.Link className="nav-link page-scroll" onClick={() => this.homeRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                        Home
                                    </Nav.Link>
                                    <Nav.Link className="nav-link page-scroll" style={{cursor: 'pointer'}} onClick={() => this.productRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}>{t('il_prodotto')}</Nav.Link>
                                    <Nav.Link className="nav-link page-scroll" style={{cursor: 'pointer'}} onClick={() => this.featuresRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}>{t('caratteristiche')}</Nav.Link>
                                    <Nav.Link className="nav-link page-scroll" style={{cursor: 'pointer'}} onClick={() => this.pianiRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}>{t('piani')}</Nav.Link>
                                    <Nav.Link className="btn btn-primary" onClick={() => window.open('https://calendly.com/appius/30min', '_blank')} style={{ color: 'white', padding: 8}}>{t('fissa_una_call')}</Nav.Link>
                                    <Nav.Link className="btn btn-primary" onClick={() => window.location.href = '/#/main/login'} style={{ color: 'white', padding: 8}}>{t('accedi')}</Nav.Link>
                                    <Nav.Link className="lang-btn" onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'it') }}><img src={ require('../../images/it.png') } style={{ width: 20, height: 'auto' }}/></Nav.Link>
                                    <Nav.Link className="lang-btn" onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'en') }}><img src={ require('../../images/en.png') } style={{ width: 20, height: 'auto' }}/></Nav.Link>
                                </Nav>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>                

                <div className="banner" style={{ height: this.state.bannerHeight }}>
                    <div className="container">
                        <div className="row" style={{ zIndex: 1000, display: 'flex', alignItems: 'center', height: '100%' }}>
                            <div className="col-md-8 offset-md-2">
                                <div className="caption">
                                    <h1 className='header1'>{t('soluzione_scuola')}</h1>
                                    <p className="sub">{ReactHtmlParser(t('gratis_sempre'))}</p>
                                    <div className="btn btn-primary" onClick={() => window.location.href = '/#/main/login?signup'} style={{ fontSize: '1em', padding: 10 }}>{t('crea_account_g')}</div>
                                    <p className="sub"><i>{t('scarica_app')}</i></p>
                                    <div className="appDiv" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                        <img src={ require('../../images/apple.png') } style={{ width: 40, height: 40, cursor: 'pointer' }} onClick={() => window.open('https://apps.apple.com/us/app/appius-academy/id1630916391', '_blank')} />
                                        <img src={ require('../../images/gplay.png') } style={{ width: 40, height: 40, marginLeft: 20, cursor: 'pointer' }} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.appiusacademy', '_blank')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <video autoPlay loop muted style={{ height: this.state.bannerHeight }}>
                            <source src={ require('../../images/video.mp4') } type="video/mp4" />
                        </video>
                    </div>
                </div>
                </header>

                <section id="about" ref={this.productRef}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 wow bounceIn" data-wow-duration=".5s" data-wow-delay=".2s">
                                <img alt="" src={require('../../images/custom_icon.png')} style={{width: 50, height: 50, marginBottom: 20}} />
                                <h4 className='header4'>{t('personalizzabile')}</h4>
                                <p>{t('pers_info')}</p>
                            </div>
                            <div className="col-md-4 wow bounceIn" data-wow-duration=".5s" data-wow-delay=".4s">
                                <img alt="" src={require('../../images/grow_icon.png')} style={{width: 50, height: 50, marginBottom: 20}} />
                                <h4 className='header4'>{t('scalabile')}</h4>
                                <p>{t('sc_info')}</p>
                            </div>
                            <div className="col-md-4 wow bounceIn" data-wow-duration=".5s" data-wow-delay=".6s">
                                <img alt="" src={require('../../images/mobile_icon.png')} style={{width: 50, height: 50, marginBottom: 20}} />
                                <h4 className='header4'>{t('app')}</h4>
                                <p>{t('app_info')}</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="features" ref={this.featuresRef} style={{ marginTop: -120, paddingTop: 120 }}>
                    <div className="container">
                        <div className="row">
                            {/*
                            <video ref={this.videoRef} style={{ position: 'absolute', left: 0, right: 0, backgroundColor: '#414141', width: '100vw', height: '350px' }} controls={this.state.playVideo ? true : false} autoPlay={this.state.playVideo ? true : false}>
                                <source src={ require('../../images/video.mp4')} type="video/mp4" />
                            </video>
                            { !this.state.playVideo && (
                                <div style={{ position: 'absolute', left: 0, right: 0, backgroundColor: '#4141414D', width: '100vw', height: '350px', textAlign: 'center', zIndex: 100, backdropFilter: 'blur(3px)' }}>
                                    <img style={{ width: '80px', height: '80px', marginTop: '135px', cursor: 'pointer'  }} onClick={ () => { this.setState({ playVideo: true }); this.videoRef.current.play(); }} src={ require('../../images/play.png') } />
                                </div>
                            )}
                            */}
                            <div className="col-md-6 col-sm-offset-2 text-center mx-auto" style={{ marginTop: 0 /*'420px'*/ }}>
                                <h2 className="section-title">{t('cosa_include')}</h2>
                                <p>{t('include_info')}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 feature wow bounceIn" data-wow-duration=".5s" data-wow-delay=".2s">
                                <div className="feature-icon">
                                    <img alt="" src={ require('../../images/manage_icon.png') } style={{ width: 80, height: 80, marginTop: 10 }} />
                                </div>
                                <h4>{t('gestione_indipendente')}</h4>
                                <p>{t('info_1')}</p>
                            </div>
                            <div className="col-md-4 feature wow bounceIn" data-wow-duration=".5s" data-wow-delay=".4s">
                                <div className="feature-icon">
                                    <img alt="" src={ require('../../images/mobile_icon_1.png') } style={{ width: 80, height: 80, marginTop: 10 }} />
                                </div>
                                <h4>{t('app')}</h4>
                                <p>{t('info_2')}</p>
                            </div>
                            <div className="col-md-4 feature wow bounceIn" data-wow-duration=".5s" data-wow-delay=".6s">
                                <div className="feature-icon">
                                    <img alt="" src={ require('../../images/easy_icon.png') } style={{ width: 80, height: 80, marginTop: 10 }} />
                                </div>
                                <h4>{t('semplicita')}</h4>
                                <p>{t('info_3')}</p>
                            </div>
                            <div className="col-md-4 feature wow bounceIn" data-wow-duration=".5s" data-wow-delay=".8s">
                                <div className="feature-icon">
                                    <img alt="" src={ require('../../images/payment_icon.png') } style={{ width: 80, height: 80, marginTop: 10 }} />
                                </div>
                                <h4>{t('fatt')}</h4>
                                <p>{t('info_4')}</p>
                            </div>
                            <div className="col-md-4 feature wow bounceIn" data-wow-duration=".5s" data-wow-delay="1s">
                                <div className="feature-icon">
                                    <img alt="" src={ require('../../images/custom_icon_1.png') } style={{ width: 80, height: 80, marginTop: 10 }} />
                                </div>
                                <h4>{t('pagamenti_pers')}</h4>
                                <p>{t('info_5')}</p>
                            </div>
                            <div className="col-md-4 feature wow bounceIn" data-wow-duration=".5s" data-wow-delay="1.2s">
                                <div className="feature-icon">
                                    <img alt="" src={ require('../../images/appello_icon.png') } style={{ width: 80, height: 80, marginTop: 10 }} />
                                </div>
                                <h4>{t('gestione_presenze_1')}</h4>
                                <p>{t('info_6')}</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="prices" ref={this.pianiRef}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 col-sm-offset-2 col-md-offset-3 text-center mx-auto">
                                <h2 className="section-title">{t('nostra_offerta')}</h2>
                                <p>{t('offerta_info')}</p>
                            </div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-lg-6 wow fadeInLeft" data-wow-duration=".5s" data-wow-delay=".2s">
                                <div className="price-table pt-5 pb-5 pe-3 ps-3">
                                    <div className="header">
                                        <h5 className="title" style={{ fontSize: 35 }}>{t('demo')}</h5>
                                        <div className="price" style={{ fontSize: 30 }}>{t('gratuito')}</div>
                                    </div>
                                    <ul style={{ marginTop: 45 }}>
                                        <li>{t('premium_4')}</li>
                                        <li>{t('premium_1')}</li>
                                        <li>{t('premium_2')}</li>
                                    </ul>
                                    <div className="btn btn-transparent" style={{ marginTop: 85 }} type="button" onClick={() => window.location.href = '#/main/login?signup'}>{t('inizia')}</div>
                                </div>
                            </div>

                            <div className="col-lg-6 wow fadeInLeft" data-wow-duration=".5s" data-wow-delay=".2s">
                                <div className="price-table  pt-5 pb-5 pe-3 ps-3">
                                    <div className="header">
                                        <h5 className="title" style={{ fontSize: 35 }}>Custom</h5>
                                        <div className="price" style={{ fontSize: 30 }}>{t('chiedi_preventivo')}</div>
                                        <h4></h4>
                                    </div>
                                    <ul style={{ marginTop: 45 }}>
                                        <li>{t('custom_1')}</li>
                                        <li>{t('custom_2')}</li>
                                        <li>{t('custom_3')}</li>
                                    </ul>
                                    <div className="btn btn-transparent" style={{ marginTop: 85 }} type="button" onClick={() => window.location.href = "mailto:info@appius.it"}>{t('richiedi')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <footer id="contact">
                    <div className="container">
                        <p>&copy; <a target='_blank' style={{ textDecoration: 'none', color: 'white' }} href="https://www.appius.it">Appius Srls</a> 2022 - {t('diritti')}.</p>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <a href="https://www.iubenda.com/privacy-policy/39158023" target='_blank' style={{ color: 'white', fontWeight: 'bold' }} title="Privacy Policy ">Privacy Policy</a>
                            <a href="https://www.iubenda.com/privacy-policy/39158023/cookie-policy" target='_blank' style={{ color: 'white', fontWeight: 'bold', marginLeft: 30 }} title="Cookie Policy ">Cookie Policy</a>
                        </div>
                    </div>
                </footer>
                <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-OERcA2EqjJCMA+/3y+gxIOqMEjwtxJY7qPCqsdltbNJuaOe923+mo//f6V8Qbsw3" crossorigin="anonymous"></script>
            </div>
        );
    }
}